import { Box } from "@mui/material";
import { useEffect, useMemo, useRef, useState } from "react";
import useAuthValue, {
  updateAuthValue,
} from "../../authModule/hooks/useAuthValue";
import useGetUserDetailQuery from "../../../modules/userModule/hooks/useGetUserDetailQuery";
import useGetHospitalDetailQuery from "../../hospitalModule/hooks/useGetHospitalDetailQuery";
import CirculatingNurseAnalysis from "./CirculatingNurseAnalysis";
import AnaesthesiaAnalysis from "./AnaesthesiaAnalysis";
import SurgeonAnalysis from "./SurgeonAnalysis";
import CustomTabs from "../../../components/CustomTabs";
import Icons from "../../../assets/Icons";
import { USER_ROLES } from "../../userModule/types/CommonTypes";
const tabData = [
  {
    id: "surgeon",
    label: "Surgeon",
    tooltip: "Surgeon_Tooltip",
    icon: <Icons.License />,
  },
  {
    id: "anaesthesia",
    label: "Anesthesia",
    tooltip: "Anaesthesia_Tooltip",
    icon: <Icons.Timeline1 />,
  },
  {
    id: "circulating-nurse",
    label: "Circulating_Nurse",
    tooltip: "Circulating_Nurse_Tooltip",
    icon: <Icons.License />,
  },
];

const RoleBasedAnalysis = ({ exportRoleBasedScreenshot }: any) => {
  const { userId, tenantId, hospitalId, user } = useAuthValue();
  const isSurgeonRole = user?.role === USER_ROLES.SURGEON;

  const visibleTabData = useMemo(
    () => (isSurgeonRole ? tabData.filter((tab) => tab.id === "surgeon") : tabData),
    [isSurgeonRole],
  );

  const [activeTab, setActiveTab] = useState<string | number>("surgeon");
  const surgeonExportRef = useRef<any>(null);
  const circulatingNurseExportRef = useRef<any>(null);
  const anaesthesiaExportRef = useRef<any>(null);

  const { isSurgeon, isAnaesthesia, isCirculatingNurse } = useMemo(() => {
    return {
      isSurgeon: activeTab === "surgeon",
      isAnaesthesia: activeTab === "anaesthesia",
      isCirculatingNurse: activeTab === "circulating-nurse",
    };
  }, [activeTab]);

  const { data: accountDetails } = useGetUserDetailQuery({
    userId: userId?.toString(),
    tenantId,
    hospitalId,
  });

  const { data: hospitalDetails } = useGetHospitalDetailQuery(hospitalId);

  useEffect(() => {
    if (accountDetails) {
      updateAuthValue({
        user: accountDetails,
      });
    }
  }, [accountDetails]);

  useEffect(() => {
    if (hospitalDetails) {
      updateAuthValue({
        hospital: hospitalDetails,
      });
    }
  }, [hospitalDetails]);

  useEffect(() => {
    if (exportRoleBasedScreenshot) {
      exportRoleBasedScreenshot.current = {
        exportRoleBasedAnalysis: () => {
          if (isSurgeon) {
            surgeonExportRef.current?.exportOverviewScreenshot?.();
          } else if (isAnaesthesia) {
            anaesthesiaExportRef.current?.exportOverviewScreenshot?.();
          } else if (isCirculatingNurse) {
            circulatingNurseExportRef.current?.exportOverviewScreenshot?.();
          }
        },
      };
    }
  }, [isSurgeon, isAnaesthesia, isCirculatingNurse, exportRoleBasedScreenshot]);

  return (
    <Box
      sx={{
        marginTop: 1,
      }}
    >
      <CustomTabs
        tabs={visibleTabData}
        activeTab={activeTab}
        onTabChange={setActiveTab}
        variant="segmented"
      />

      <Box mt={2}>
        {isSurgeon && (
          <SurgeonAnalysis exportRoleBaesdScreenshot={surgeonExportRef} />
        )}
        {isAnaesthesia && (
          <AnaesthesiaAnalysis
            exportRoleBaesdScreenshot={anaesthesiaExportRef}
          />
        )}
        {isCirculatingNurse && (
          <CirculatingNurseAnalysis
            exportRoleBaesdScreenshot={circulatingNurseExportRef}
          />
        )}
      </Box>
    </Box>
  );
};

export default RoleBasedAnalysis;
